import styled from 'styled-components';

import Text, { TextColor, TextVariant } from 'src/components/atoms/Text';
import Modal, { ModalVariant } from 'src/components/organisms/Modal';

const Rows = styled.dl`
  margin: 1rem 0 0;
  text-align: left;
`;

const Row = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  margin-top: 0.75rem;

  dt {
    color: ${({ theme }) => theme.color.gray[600]};
  }

  dd {
    margin: 0;
    font-weight: 600;
  }
`;

const NoteBlock = styled.dl`
  margin-top: 1rem;
  text-align: left;

  dt {
    color: ${({ theme }) => theme.color.gray[600]};
  }

  dd {
    margin: 0.25rem 0 0;
    font-weight: 600;
    white-space: pre-wrap;
    overflow-wrap: anywhere;
  }
`;

export interface SendReportConfirmModalProps {
  show: boolean;
  monthlyIncome: string;
  assetValue: string;
  reasonLabel: string;
  note?: string;
  isLoading?: boolean;
  onConfirm: () => void | Promise<void>;
  onCancel: () => void;
}

const SendReportConfirmModal = ({
  show,
  monthlyIncome,
  assetValue,
  reasonLabel,
  note,
  isLoading,
  onConfirm,
  onCancel
}: SendReportConfirmModalProps) => (
  <Modal
    title="Send report with this override?"
    showModal={show}
    variant={ModalVariant.none}
    labelButtonConfirm="Send report"
    labelButtonCancel="Cancel"
    isLoadingButtonConfirm={isLoading}
    isDisabledButtonCancel={isLoading}
    onConfirm={onConfirm}
    onCancel={onCancel}
    data-testid="send-report-confirm-modal"
  >
    <Text color={TextColor.gray600} variant={TextVariant.normal}>
      This sends the report with the income override below and completes the specialty review. This
      can&apos;t be undone.
    </Text>
    <Rows>
      <Row>
        <dt>Monthly income</dt>
        <dd data-testid="confirm-monthly-income">{monthlyIncome}</dd>
      </Row>
      <Row>
        <dt>Asset value</dt>
        <dd data-testid="confirm-asset-value">{assetValue}</dd>
      </Row>
      <Row>
        <dt>Override reason</dt>
        <dd data-testid="confirm-reason">{reasonLabel}</dd>
      </Row>
    </Rows>
    {note && (
      <NoteBlock>
        <dt>Calculation note</dt>
        <dd data-testid="confirm-note">{note}</dd>
      </NoteBlock>
    )}
  </Modal>
);

export default SendReportConfirmModal;
